import { ReactElement, useCallback, useMemo } from 'react';
import { DecimalField } from '@ff-it/form';
import { Checkbox, Td, Tr } from '@ff-it/ui';
import { parseBig, required, gt, fmt } from 'utilities';
import { RemoveButton } from 'components';

interface CommissionProps {
  prevTarget?: string;
  nextTarget?: string;
  index: number;
  remove?: (index: number) => void;
  current: boolean;
  setCurrent: (index: number) => void;
  execution?: string;
}

export function Commission({
  execution,
  index,
  remove,
  nextTarget,
  prevTarget,
  current,
  setCurrent,
}: CommissionProps): ReactElement {
  const next = useMemo(() => (nextTarget ? fmt(parseBig(nextTarget).minus('0.01'), false, true) : '-'), [nextTarget]);
  const validateTarget = useCallback(
    (val?: string) => {
      return required(val) || prevTarget ? gt(parseBig(prevTarget))(val) : undefined;
    },
    [prevTarget],
  );

  const disable = !prevTarget && index !== 0;
  return (
    <Tr>
      <Td flush textAlign="center">
        <Checkbox
          variant="radio"
          className="text-center mb-0"
          size="sm"
          checked={current}
          onChange={(e) => {
            e.target.checked && setCurrent(index);
          }}
        />
      </Td>
      <Td>
        <DecimalField
          name={`commission[${index}].target`}
          validate={validateTarget}
          disabled={disable}
          className="mb-0"
          size="sm"
        />
      </Td>
      <Td textAlign="right" valign="middle">
        {next}
      </Td>
      <Td>
        <DecimalField
          name={`commission[${index}].rate`}
          className="text-right mb-0"
          validate={required}
          disabled={disable}
          size="sm"
        />
      </Td>
      <Td textAlign="right" valign="middle" fontWeight="bold">
        {execution}
      </Td>

      <Td flush textAlign="center">
        {remove && <RemoveButton onClick={() => remove(index)} testId="remove-inline" />}
      </Td>
    </Tr>
  );
}
